import React from 'react';

const routeLoader = LoadingComponent => (load) => {
    let initialized;
    let component;
    let cancel;
    return class Loader extends React.Component {
        constructor(props) {
            super(props);
            this.component = component;
        }
        componentDidMount() {
            if (initialized) {
                return;
            }
            initialized = true;
            load((Component) => {
                this.component = Component.default || Component;
                component = this.component;
                if (!cancel) {
                    this.forceUpdate();
                }
            });
        }
        componentWillUnmount() {
            cancel = true;
        }
        render() {
            if (this.component) {
                return React.createElement(this.component, this.props);
            }
            return <LoadingComponent />;
        }
    };
};

export default routeLoader;



// WEBPACK FOOTER //
// ./src/client/hoc/routeLoader.js